export default __webpack_public_path__ + "static/media/pencil.67b5db1f.svg";